<template>
  <v-layout column ma-1>
    <v-card >
      <v-layout align-center justify-center row fill-height title pa-2>
          <mrx-translation :token="'questions.malaria.child_test_id'"></mrx-translation> &nbsp; <v-flex>{{ childTestId }}</v-flex>
      </v-layout>
    </v-card>
  </v-layout>
</template>

<script>
  export default {
    name: 'MalariaTestNumber',
    model: {
      prop: 'items',
      event: 'click'
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String
    },
    data() {
      return {
        childTestId: null
      }
    },
    generateChildTestId() {
      const x = Math.floor(Math.random() * (999 - 100 + 1) + 100)
      const y = Math.floor(Math.random() * (999 - 100 + 1) + 100)
      return `${this.$i18n.n(x)}${this.$i18n.n(y)}`
    },
    created() {
      this.childTestId = this.generateChildTestId()
      this.$store.state.settings.malaria_rdt_random_num = this.childTestId
      this.items[0].selected = true
    },
    methods: {}
  }
</script>

<style scoped>
  .white-imp {
    background-color: white !important;
  }
</style>
